import F84Game from "../Game";

export default class LottieSprite extends Phaser.GameObjects.Sprite {
    private _anim: any; //lottie animation

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, autoplay: boolean, loop: boolean) {
        super(scene, x, y, texture);

        this.scene.game.events.on("prerender", this.onGamePrerender, this);

        const animations: Array<any> = (<any>window).lottie.getRegisteredAnimations();
        this._anim = animations.find((animation) => animation.key == texture);
        this._anim.loop = loop;
        this._anim.autoplay = autoplay;
        if (autoplay) {
            this.playAnim();
        } else {
            this.stopAnim();
        }
    }

    public playAnim(): this {
        this._anim.play();
        return this;
    }

    public stopAnim(): void {
        this._anim.stop();
    }

    public pauseAnim(): void {
        this._anim.pause();
    }

    public goToAndStop(value: number, isFrame?: boolean): void {
        this._anim.goToAndStop(value, isFrame);
    }

    public setSpeed(speed: number): void {
        this._anim.setSpeed(speed);
    }

    private onGamePrerender(): void {
        (<Phaser.Textures.CanvasTexture>this.texture).refresh();
    }

    public destroy(): void {
        if (this.scene) this.scene.game.events.off("prerender", this.onGamePrerender, this);
        else F84Game.Instance.events.off("prerender", this.onGamePrerender, this); //kludge
        super.destroy();
    }
}
